"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PasswordIndicator = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledPasswordIndicator = require("./styled-password-indicator");
var _excluded = ["state", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  state: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
var defaultProps = {
  state: 'default',
  dataTestId: 'fuse-password-indicator-data-test-id'
};
var componentName = _config.DefaultConfig.componentName;
var PasswordIndicator = exports.PasswordIndicator = forwardRef(function (_ref, ref) {
  var _IndicatorConfig$stat, _IndicatorConfig$stat2;
  var state = _ref.state,
    dataTestId = _ref.dataTestId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var labelText = _config.IndicatorConfig === null || _config.IndicatorConfig === void 0 || (_IndicatorConfig$stat = _config.IndicatorConfig[state]) === null || _IndicatorConfig$stat === void 0 ? void 0 : _IndicatorConfig$stat.label;
  var colour = _config.IndicatorConfig === null || _config.IndicatorConfig === void 0 || (_IndicatorConfig$stat2 = _config.IndicatorConfig[state]) === null || _IndicatorConfig$stat2 === void 0 ? void 0 : _IndicatorConfig$stat2.colour;
  return /*#__PURE__*/_react["default"].createElement(_styledPasswordIndicator.StyledIndicatorWrapper, _extends({
    ref: ref,
    "data-testid": dataTestId
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledPasswordIndicator.StyledIndicatorContainer, null, Object.keys(_config.IndicatorConfig).map(function (index, key) {
    var _IndicatorConfig$stat3, _IndicatorConfig$stat4;
    return /*#__PURE__*/_react["default"].createElement(_styledPasswordIndicator.StyledIndicator, {
      colour: (_config.IndicatorConfig === null || _config.IndicatorConfig === void 0 || (_IndicatorConfig$stat3 = _config.IndicatorConfig[state]) === null || _IndicatorConfig$stat3 === void 0 ? void 0 : _IndicatorConfig$stat3.colourCountIndex) > key ? colour : undefined,
      key: _config.IndicatorConfig === null || _config.IndicatorConfig === void 0 || (_IndicatorConfig$stat4 = _config.IndicatorConfig[state]) === null || _IndicatorConfig$stat4 === void 0 ? void 0 : _IndicatorConfig$stat4.colourCountIndex.keyId,
      "data-testid": "".concat(componentName, "__indicator--").concat(index)
    });
  })), /*#__PURE__*/_react["default"].createElement(_styledPasswordIndicator.StyledText, {
    "aria-live": "polite",
    colour: colour
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "This is a password indicator. It determines the strength of your password.", ' '), state !== 'default' && /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "Your password is ") && labelText));
});
PasswordIndicator.propTypes = propTypes;
PasswordIndicator.defaultProps = defaultProps;
var _default = exports["default"] = PasswordIndicator;